// =========================
// Enums
// =========================

export enum ScheduleStatus {
  PENDING = 'PENDING',
  TO_BE_UPPLOAD_CSV = 'TO_BE_UPPLOAD_CSV',
  CSV_UPLOADING = 'CSV_UPLOADING',
  CSV_AWAITING_CONSOLIDATION = 'CSV_AWAITING_CONSOLIDATION',
  CSV_READY = 'CSV_READY',
  PARTIAL_CSV_READY = 'PARTIAL_CSV_READY',
  PLANNED = 'PLANNED',
  PARTIAL_PLANNED = 'PARTIAL_PLANNED',
  STOP_IN_PROCESS = 'STOP_IN_PROCESS',
  STOPPED_RESCHEDULABLE = 'STOPPED_RESCHEDULABLE',
  NOTIFIED = 'NOTIFIED',
  PARTIAL_NOTIFIED = 'PARTIAL_NOTIFIED',
  EXPIRED = 'EXPIRED',
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  UNKNOWN = 'UNKNOWN'
}

export enum TouchpointStatus {
  UPLOAD_IN_PROCESS = 'UPLOAD_IN_PROCESS',
  CSV_READY = 'CSV_READY',
  PLANNED = 'PLANNED',
  PLAN_ERROR = 'PLAN_ERROR',
  MISSING = 'MISSING',
  DELETED = 'DELETED',
  UNKNOWN = 'UNKNOWN'
}

// =========================
// Request DTOs
// =========================

export class ScheduleNotificationRequest {
  challengeId: number;
  pushMessage: string;
  notifyTime: string;
}

export class UpdateScheduleStateRequest {
  challengeId: number;
  requestedStatus: ScheduleStatus;
}

export class DirectNotificationRequest {
  customerId: number;
  challengeId: number;
  pushMessage: string;
}

export class ScheduleContextUpdateRequest {
  challengeId: number;
}

// =========================
// Response DTOs
// =========================

export class ErrorDto {
  code: number;
  message: string;
}

export class DefaultErrorResponseEntity {
  timestamp: string;
  error: string;
  path: string;
  code: number;
  status: number;
  'requester-id': string;
}

export class PreparedScheduleResponse {
  id: number;
  challengeId: number;
  message: string;
  notifyAt: string;
  operationTakenOn: boolean;
}

export class AllPendingSchedulePageResponse {
  content: PreparedScheduleResponse[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

export class ScheduleStatusResponse {
  status: ScheduleStatus;
}

export class ScheduleTouchpointResponse {
  id: number;
  touchPointName: string;
  staticListName: string;
  airshipScheduleId: string;
  status: TouchpointStatus;
  error?: ErrorDto;
}

export class ScheduleResponse {
  headId: number;
  hostId: number;
  challengeId: number;
  operationTakenOn: boolean;
  message: string;
  notifyAt: string;
  status: ScheduleStatus;
  childList: ScheduleTouchpointResponse[];
}

export class AllSchedulePageResponse {
  content: ScheduleResponse[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

// =========================
// Status Colors
// =========================

export enum StatusColor {
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  RED = 'RED',
  UNKNOWN = 'UNKNOWN'
}

const GREEN_STATUS: string[] = [
  'PENDING', 'TO_BE_UPPLOAD_CSV', 'CSV_UPLOADING',
  'CSV_AWAITING_CONSOLIDATION', 'CSV_READY', 'PLANNED', 'NOTIFIED'
];

const ORANGE_STATUS: string[] = [
  'PARTIAL_CSV_READY', 'PARTIAL_PLANNED', 'PARTIAL_NOTIFIED'
];

const RED_STATUS: string[] = [
  'STOP_IN_PROCESS', 'PROCESSING_ERROR', 'STOPPED_RESCHEDULABLE'
];

export function getStatusColor(status: string): StatusColor {
  if (GREEN_STATUS.indexOf(status) !== -1) return StatusColor.GREEN;
  if (ORANGE_STATUS.indexOf(status) !== -1) return StatusColor.ORANGE;
  if (RED_STATUS.indexOf(status) !== -1) return StatusColor.RED;
  return StatusColor.UNKNOWN;
}

export const STATUS_LABEL: Record<string, string> = {
  PENDING:                    'In attesa',
  TO_BE_UPPLOAD_CSV:          'Da caricare CSV',
  CSV_UPLOADING:              'Caricamento CSV',
  CSV_AWAITING_CONSOLIDATION: 'Consolidamento CSV',
  CSV_READY:                  'CSV pronto',
  PARTIAL_CSV_READY:          'CSV parzialmente pronto',
  PLANNED:                    'Pianificato',
  PARTIAL_PLANNED:            'Parzialmente pianificato',
  STOP_IN_PROCESS:            'Stop in corso',
  STOPPED_RESCHEDULABLE:      'Fermato (ripianificabile)',
  NOTIFIED:                   'Notificato',
  PARTIAL_NOTIFIED:           'Parzialmente notificato',
  EXPIRED:                    'Scaduto',
  PROCESSING_ERROR:           'Errore elaborazione',
  UNKNOWN:                    'Sconosciuto',
};

export function getStatusLabel(status: string): string {
  return STATUS_LABEL[status] != null ? STATUS_LABEL[status] : status;
}
// =========================
// Touchpoint Status Colors
// =========================

const TOUCHPOINT_GREEN_STATUS: string[] = ['UPLOAD_IN_PROCESS', 'CSV_READY', 'PLANNED'];
const TOUCHPOINT_ORANGE_STATUS: string[] = ['MISSING'];
const TOUCHPOINT_RED_STATUS: string[] = ['PLAN_ERROR', 'DELETED'];

export function getTouchpointStatusColor(status: string): StatusColor {
  if (TOUCHPOINT_GREEN_STATUS.indexOf(status) !== -1) return StatusColor.GREEN;
  if (TOUCHPOINT_ORANGE_STATUS.indexOf(status) !== -1) return StatusColor.ORANGE;
  if (TOUCHPOINT_RED_STATUS.indexOf(status) !== -1) return StatusColor.RED;
  return StatusColor.UNKNOWN;
}

// =========================
// Notification Commands
// =========================

export enum NotificationCommand {
  DELETE = 'DELETE',
  RESEND = 'RESEND',
  VIEW_STATUS = 'VIEW_STATUS'
}

export interface NotificationStatus {
  id: number;
  dataOra: string;
  stato: string;
  messaggio: string;
}

// Stati che mostrano DELETE
export const DELETE_STATES: string[] = [
  'PLANNED', 'PARTIAL_PLANNED', 'PROCESSING_ERROR'
];

// Stati che mostrano RESEND
export const RESEND_STATES: string[] = [
  'PLANNED', 'PARTIAL_PLANNED', 'STOPPED_RESCHEDULABLE', 'PROCESSING_ERROR'
];

export class MessageInstanceActionStatusDto {
  status: string;
  nextStep: string[];
  acceptCommand: string[];
}


// WEBPACK FOOTER //
// ./src/app/views/notification/model/notification-model.ts